import { highestSeverity, severityToken } from './severity';
import type { GenericWarning } from './types';

/**
 * Group warnings by their type and order the groups by highest severity (blockers first,
 * then warnings, then hints) — the shared ordering used by the test modal and the wizard pre-flight.
 */
export function groupWarningsBySeverity(warnings: GenericWarning[]): [string, GenericWarning[]][] {
  const byType = new Map<string, GenericWarning[]>();
  for (const warning of warnings) {
    const list = byType.get(warning.type) ?? [];
    list.push(warning);
    byType.set(warning.type, list);
  }

  const rank = (group: GenericWarning[]) => {
    const level = highestSeverity(group.map((warning) => warning.priority));
    return (level ? severityToken(level) : severityToken('info')).rank;
  };

  return [...byType.entries()].sort(([, a], [, b]) => rank(a) - rank(b));
}
